import history from './history'
import upload from './upload'
import summary from './summary'
import progress from './progress'

export default { history, upload, summary, progress }
